<template>
  <div class="flex min-h-screen flex-col">
    <div class="flex w-full grow flex-col">
      <header
        v-if="$slots.header"
        class="w-full"
        :class="[
          $slots.header && !$slots.main ? 'grow' : '',
          props.collapseHeader ? '' : 'pt-32 md:pt-36',
        ]"
      >
        <slot name="header" />
      </header>
      <main
        v-if="$slots.main"
        class="w-full"
        :class="$slots.main && !$slots.header ? 'grow' : ''"
      >
        <slot name="main" />
      </main>
    </div>
    <PageFooter
      v-if="!props.hideFooter"
      class="w-full"
      :class="props.altFooter ? 'bg-grey' : 'bg-white'"
      :cta="props.footerCta"
    />
  </div>
</template>

<script setup lang="ts">
interface PageContainerProps {
  altFooter?: boolean
  collapseHeader?: boolean
  footerCta?: boolean
  hideFooter?: boolean
}

const props = withDefaults(defineProps<PageContainerProps>(), {
  altFooter: false,
  collapseHeader: false,
  footerCta: true,
  hideFooter: false,
})
</script>
